const currencySymbol = window.marque.ui.localisation.currency_symbol;
const currencySymbolSize = window.marque.ui.localisation.currency_symbol_size;
export { currencySymbol, currencySymbolSize };
